// src/components/qualtrics/qualtrics.tsx
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  query QualtricsConfigQuery($context: ContextInput!) {\n    qualtricsConfig(context: $context) {\n      zoneId\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// src/components/qualtrics/qualtrics-log-utils.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var QUALTRICS_EVENTS = {
  INIT: new SystemEvent(SystemEventLevel.INFO, "INIT_QUALTRICS"),
  INIT_ERROR: new SystemEvent(SystemEventLevel.ERROR, "INIT_ERROR_QUALTRICS")
};
var buildLogMessage = function (message) {
  var _window;
  if ((_window = window) === null || _window === void 0 ? void 0 : _window.tc_vars) {
    var _window_tc_vars = window.tc_vars,
      event_page_name = _window_tc_vars.event_page_name,
      point_of_sale_eg_pos_id = _window_tc_vars.point_of_sale_eg_pos_id,
      language = _window_tc_vars.language,
      identifiers_session_id = _window_tc_vars.identifiers_session_id;
    return "".concat(message, " pageName=").concat(event_page_name, " point_of_sale_id=").concat(point_of_sale_eg_pos_id, " language=").concat(language, " sessionId=").concat(identifiers_session_id);
  }
  return message;
};
var logDisplayableActionSet = function (logger, evaluation, intercept) {
  var _intercept_ActionSets_find;
  var actionSet = evaluation.Decision.ActionSetID;
  var actionSetName = (_intercept_ActionSets_find = intercept.ActionSets.find(function (item) {
    return item.ActionSetID === actionSet;
  })) === null || _intercept_ActionSets_find === void 0 ? void 0 : _intercept_ActionSets_find.Label;
  logger.INIT.log(buildLogMessage("Qualtrics ready to display - actionSet=[id:".concat(actionSet, " name:").concat(actionSetName, " interceptId:").concat(intercept.InterceptID, "]")));
};
var logEvaluatedIntercept = function (logger) {
  var _window;
  var qsi = typeof window === "undefined" ? null : (_window = window) === null || _window === void 0 ? void 0 : _window.QSI;
  if (!qsi.API) {
    logger.INIT_ERROR.log(buildLogMessage("Error during Qualtrics initialization - QSI.API not available"));
  } else {
    Object.keys(qsi.Request[qsi.config.zoneId].Intercepts).forEach(function (siid) {
      qsi.API.getIntercept(siid).then(function (interceptAPI) {
        var _interceptAPI, _interceptAPI1;
        var evaluation = (_interceptAPI = interceptAPI) === null || _interceptAPI === void 0 ? void 0 : _interceptAPI.evaluation;
        var intercept = (_interceptAPI1 = interceptAPI) === null || _interceptAPI1 === void 0 ? void 0 : _interceptAPI1.intercept;
        var evaluationResult = interceptAPI.getEvaluationResult();
        if (evaluationResult.passed) {
          var _evaluationResult_creative, _evaluationResult;
          logger.INIT.log(buildLogMessage("Qualtrics initialization successful for survey=[id:".concat(intercept.InterceptID, " name:").concat(intercept.Name, " creative:").concat(((_evaluationResult = evaluationResult) === null || _evaluationResult === void 0 ? void 0 : (_evaluationResult_creative = _evaluationResult.creative) === null || _evaluationResult_creative === void 0 ? void 0 : _evaluationResult_creative.name) || "", "]")));
          logDisplayableActionSet(logger, evaluation, intercept);
          interceptAPI.onClose(function () {
            logger.INIT.log(buildLogMessage("Qualtrics interceptId=".concat(intercept.InterceptID, " has been closed")));
          });
        } else {
          var _evaluationResult_creative1, _evaluationResult1;
          logger.INIT_ERROR.log(buildLogMessage("Qualtrics initialization failed for survey=[id:".concat(intercept.InterceptID, " name:").concat(intercept.Name, " creative:").concat(((_evaluationResult1 = evaluationResult) === null || _evaluationResult1 === void 0 ? void 0 : (_evaluationResult_creative1 = _evaluationResult1.creative) === null || _evaluationResult_creative1 === void 0 ? void 0 : _evaluationResult_creative1.name) || "", "]")));
        }
      });
    });
  }
};
// src/components/external-scripts/script-blob.ts
var initQualtrics = function (zoneId) {
  var g = function g(e, h, f, g2) {
    this.get = function (a) {
      for (var a = "".concat(a, "="), c = document.cookie.split(";"), b = 0, e2 = c.length; b < e2; b++) {
        for (var d = c[b]; d.charAt(0) == " ";) {
          d = d.substring(1, d.length);
        }
        if (d.indexOf(a) == 0) {
          return d.substring(a.length, d.length);
        }
      }
      return null;
    };
    this.set = function (a, c) {
      var b = "";
      var b = /* @__PURE__ */new Date();
      b.setTime(b.getTime() + 6048e5);
      b = "; expires=".concat(b.toGMTString());
      document.cookie = "".concat(a, "=").concat(c).concat(b, "; path=/; ");
    };
    this.check = function () {
      var a = this.get(f);
      if (a) {
        a = a.split(":");
      } else if (e != 100) {
        h == "v" && (e = Math.random() >= e / 100 ? 0 : 100), a = [h, e, 0], this.set(f, a.join(":"));
      } else {
        return true;
      }
      var c = a[1];
      if (c == 100) {
        return true;
      }
      switch (a[0]) {
        case "v":
          return false;
        case "r":
          return c = a[2] % Math.floor(100 / c), a[2]++, this.set(f, a.join(":")), !c;
      }
      return true;
    };
    this.go = function () {
      if (this.check()) {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.src = g2;
        document.body && document.body.appendChild(a);
      }
    };
    this.start = function () {
      var t = this;
      document.readyState !== "complete" ? window.addEventListener ? window.addEventListener("load", function () {
        t.go();
      }, false) : window.attachEvent && window.attachEvent("onload", function () {
        t.go();
      }) : t.go();
    };
  };
  try {
    new g(100, "r", "QSI_S_".concat(zoneId), "https://".concat(zoneId.toLowerCase().replace(/_/g, ""), "-expediainc.siteintercept.qualtrics.com/SIE/?Q_ZID=").concat(zoneId)).start();
  } catch (i) {}
};
var script_blob_default = initQualtrics;
// src/components/qualtrics/qualtrics.tsx
var __Query = gql(_templateObject());
var Qualtrics = function (props) {
  var _data_qualtricsConfig, _data;
  var context = useBexApi().context;
  var skipSsr = props.skipSsr,
    onInit = props.onInit;
  var variables = {
    context: context
  };
  var _useQuery = useQuery(__Query, {
      variables: variables,
      fetchPolicy: "network-only",
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var logger = useLoggerEvents(QUALTRICS_EVENTS);
  var zoneId = (_data = data) === null || _data === void 0 ? void 0 : (_data_qualtricsConfig = _data.qualtricsConfig) === null || _data_qualtricsConfig === void 0 ? void 0 : _data_qualtricsConfig.zoneId;
  React.useEffect(function () {
    return function () {
      var _window, _window1, _qsi;
      var qsi = typeof window === "undefined" ? null : (_window = window) === null || _window === void 0 ? void 0 : _window.QSI;
      var tcVars = typeof window === "undefined" ? null : (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.tc_vars;
      if ((_qsi = qsi) === null || _qsi === void 0 ? void 0 : _qsi.API) {
        qsi.API.unload();
        var oldPageName = tcVars.event_page_name;
        var counter = 1;
        var interval = setInterval(function () {
          if (oldPageName !== tcVars.event_page_name) {
            qsi.API.unload();
            qsi.API.load();
            qsi.API.run();
            clearInterval(interval);
          } else if (counter === 100) {
            clearInterval(interval);
            qsi.API.unload();
            qsi.API.load();
            qsi.API.run();
          }
          counter += 1;
        }, 100);
      }
    };
  }, []);
  React.useEffect(function () {
    if (zoneId) {
      var _onInit;
      (_onInit = onInit) === null || _onInit === void 0 ? void 0 : _onInit(zoneId);
      script_blob_default(zoneId);
      window.addEventListener("qsi_js_loaded", function () {
        return logEvaluatedIntercept(logger);
      }, false);
    }
  }, [zoneId]);
  if (loading || error || !zoneId) {
    if (!loading) {
      logger.INIT_ERROR.log(buildLogMessage(error ? "Error during Qualtrics initialization - error=".concat(error) : "Error during Qualtrics initialization - missing zoneId"));
    }
    return null;
  }
  return /* @__PURE__ */React.createElement("div", {
    "data-stid": zoneId,
    id: zoneId
  });
};
Qualtrics.displayName = "sharedui-Qualtrics";
export { Qualtrics }; /* istanbul ignore file -- @preserve */ /* istanbul ignore next -- @preserve */